import { PropsWithChildren } from 'react';
import { Text } from '@/components/base';

interface ManualOpenStepProps {
  step: number;
  label: string;
}

// One numbered step; `children` is the host-menu icon the step points at.
export const ManualOpenStep = ({ step, label, children }: PropsWithChildren<ManualOpenStepProps>) => (
  <div className="flex items-center gap-3 rounded-xl bg-revamp-gray-100 px-3 py-2.5">
    <Text
      version="revamp-v1"
      is="span"
      className="flex size-[22px] shrink-0 items-center justify-center rounded-full bg-revamp-cobalt-400 text-[13px] font-bold leading-4 text-white"
    >
      {step}
    </Text>
    <Text version="revamp-v1" variant="body5" className="flex-1 font-medium text-revamp-gray-900">
      {label}
    </Text>
    {children}
  </div>
);
